






















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class LogoutConfirmation extends Vue {
    @Prop({ default: false }) openConfirmation: boolean;
    @Prop() closeConfirmation: Function;
}
